export default __webpack_public_path__ + "static/media/Wheel.1ccdbb51.png";